import { To, useNavigate } from 'react-router-dom'

import { PerformanceProcessTargetCardFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import { EvaluationCardBase } from 'modules/performance_process/components/common/EvaluationCardBase'

export const EvaluationTargetCard: React.FC<{
  evaluation: PerformanceProcessTargetCardFragment
  to: To
  isYou?: boolean
}> = ({
  evaluation: {
    id,
    evaluationType,
    targetAccess,
    reviewerAccess,
    status,
    publishedAt,
    republishedAt,
    performanceReviewProcess,
    _policies,
    answeredQuestionnaires,
    answeredQuestionnairesIdentifier,
  },
  to,
  isYou = false,
}) => {
  const navigate = useNavigate()

  const participant = {
    fullName: targetAccess?.fullName ?? '',
    avatar: targetAccess?.avatar ? buildUrl(targetAccess.avatar) : undefined,
    isYou,
  }

  const canReplaceReviewer = !!(_policies?.replaceReviewer.can && targetAccess && reviewerAccess)
  const visibleAnswers = !!answeredQuestionnairesIdentifier?.id
  const canRepublish = answeredQuestionnaires?._policies?.republish?.can ?? false

  const handleCardClick = () => (visibleAnswers || status === 'pending') && navigate(to)

  const handleRepublish = () => {
    navigate(to, { state: { isRepublishing: true } })
  }

  return (
    <EvaluationCardBase
      participant={participant}
      evaluationType={evaluationType}
      status={status}
      publishedAt={publishedAt}
      republishedAt={republishedAt}
      endsAt={performanceReviewProcess?.endsAt}
      onClick={handleCardClick}
      onRepublish={canRepublish ? handleRepublish : undefined}
      canReplaceReviewer={canReplaceReviewer}
      evaluationId={id}
      hideStatus
    />
  )
}
